import React, { Component } from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from '@material-ui/core';

import Button from '../../../Button';
import { I18n, Translate } from 'react-redux-i18n';

class ModalConfidResalys extends Component {
	constructor(props) {
		super(props);
		this.state = {
			client_name: '',
			login: '',
			password: '',
			base_id: '',
			pos_code: '',
		};
	}

	copyToken = async value => {
		await navigator.clipboard.writeText(value);

		alert(I18n.t('partner.copied'));
	};

	onChange = (key, value) => {
		this.setState({ [key]: value });
	};

	onValid = () => {
		let form = JSON.parse(JSON.stringify({ ...this.state }));

		for (let key in form) {
			form[key] = form[key].trim();
			if (key === 'client_name') {
				form[key] = form[key].replace('https://', '');
				form[key] = form[key].replace('http://', '');
				form[key] = form[key].replace('www.', '');
				const split = form[key].split('.resalys');
				form[key] = split[0];
			}
		}

		this.props.onValid(form);
	};

	isFormCompleted = () => {
		return Object.values(JSON.parse(JSON.stringify({ ...this.state }))).some(
			i => i.trim() == ''
		);
	};

	render() {
		const token = this.props.id;
		const btnDisabled = this.isFormCompleted();

		return (
			<Dialog
				onClose={this.props.onClose}
				open={this.props.open}
				id={'dialog-payment-types'}>
				<DialogTitle>
					<Translate value={'partner.resalys.modal_title'} />
				</DialogTitle>
				<DialogContent>
					<div onClick={() => this.copyToken(token)}>
						<p>
							{I18n.t('partner.resalys.copy_token')}
							<span style={{ fontSize: 20 }}>{token}</span>
						</p>
					</div>
					<DialogContentText>
						{I18n.t('partner.resalys.fill_form')}
					</DialogContentText>

					<div style={{ marginBottom: 10 }}>
						<TextField
							onChange={e => this.onChange('client_name', e.target.value)}
							value={this.state.client_name || ''}
							variant={'outlined'}
							size="small"
							placeholder={'WSDL'}
							label={'WSDL'}
						/>
					</div>
					<div style={{ marginBottom: 10 }}>
						<TextField
							onChange={e => this.onChange('base_id', e.target.value)}
							value={this.state.base_id || ''}
							variant={'outlined'}
							size="small"
							placeholder={'Base ID'}
							label={'Base ID'}
						/>
					</div>
					<div style={{ marginBottom: 10 }}>
						<TextField
							onChange={e => this.onChange('login', e.target.value)}
							value={this.state.login || ''}
							variant={'outlined'}
							size="small"
							placeholder={'Identifiant'}
							label={'Identifiant'}
						/>
					</div>
					<div style={{ marginBottom: 10 }}>
						<TextField
							onChange={e => this.onChange('password', e.target.value)}
							value={this.state.password || ''}
							variant={'outlined'}
							size="small"
							type="password"
							placeholder={'Mot de passe'}
							label={'Mot de passe'}
						/>
					</div>
					<div>
						<TextField
							onChange={e => this.onChange('pos_code', e.target.value)}
							value={this.state.pos_code || ''}
							variant={'outlined'}
							size="small"
							placeholder={'Code du TPV'}
							label={'Code du TPV'}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					{' '}
					<Button onClick={this.props.onClose}>
						<Translate value={'general.close'} />
					</Button>
					<Button onClick={this.onValid} disabled={btnDisabled}>
						<Translate value={'general.valid'} />
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

export default ModalConfidResalys;
